/**
 * Store module for keeping all the (dynamic) constants
 */
const state = {
  consts: {
    AGG_METHOD_ADAPT_COPELAND: 'adaptive_copeland_agg',
    AGG_METHOD_AVERAGE: 'mean',
    REPORT_STATUS: {
      NO_RATING: {
        display: false,
        message: 'No report was rated'
      },
      NO_REPORT: {
        display: false,
        message: 'No report was submitted'
      },
      NOT_READY: {
        display: true,
        message: "Report rated as not 'ready' for evaluation"
      },
      ONE_RATING: {
        display: true,
        message: 'Insufficient ratings'
      },
      READY: {
        display: true,
        message: 'Report ready for evaluation'
      }
    },
    EXT_URL: {
      HELP_CENTER: 'https://swarm-help.zendesk.com/hc/en-us',
      LEARNING_CENTER: 'https://swarm-learning.thinkific.com/users/sign_in',
      LENS_KIT:
        'https://swarm-help.zendesk.com/hc/en-us/categories/360000312751'
    }
  }
}

const getters = {
  CONSTS: state => state.consts
}

export default {
  state,
  getters
}
